<script>
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  strToJson,
  judgmentType,
  stringDateFormat,
  diffReqData,
  diffResData
} from "@/assets/js/utils";
import Prism from "@/assets/js/prism";

Component.registerHooks(["beforeRouteUpdate"]);

@Component
export default class Document extends Vue {
  render() {
    return (
      <div
        class={{
          "second-delete": this.getSecondDocData.status === "-1",
          docs: true,
          "docs-pd": true
        }}
      >
        <div class="docs-item">
          <span class="docs-title">是否异步：</span>
          {this.isEdit ? (
            <el-select size="small" v-model={this.getSecondDocData.async_state}>
              <el-option value="2" label="是" />
              <el-option value="1" label="否" />
            </el-select>
          ) : (
            <span>
              {this.getSecondDocData.async_state === "2" ? "是" : "否"}
            </span>
          )}
        </div>
        <div class="docs-item">
          <span class="docs-title">文档分类：</span>
          {this.isEdit ? (
            <el-cascader
              class="docs-type-sel"
              size="small"
              expand-trigger="hover"
              options={this.getTitleCascader}
              v-model={this.cascader.data}
              onChange={this.handleChange}
            />
          ) : (
            <span>{this.cascader.text}</span>
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">
            接口名：
            {this.isEdit ? (
              <el-input
                size="small"
                class="docs-apiname-input"
                v-model={this.getSecondDocData.name}
                placeholder="请输入名称"
              />
            ) : (
              <span>{this.getSecondDocData.name}</span>
            )}
          </p>
          {this.isEdit ? (
            <div class="docs-item-content">
              <el-input
                class="docs-textarea"
                type="textarea"
                resize="none"
                autosize={{ minRows: 2 }}
                placeholder="请输入描述"
                v-model={this.getSecondDocData.desp}
              />
            </div>
          ) : (
            <p
              class="docs-text"
              domPropsInnerHTML={this.getSecondDocData.desp}
            />
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">接口访问限制</p>
          {this.isEdit ? (
            <div class="docs-item-content">
              <div class="docs-limit-chunk">
                <span>访问级别：</span>
                <el-select
                  size="small"
                  v-model={this.getSecondDocData.visite_level}
                >
                  <el-option value="1" label="普通接口" />
                  <el-option value="2" label="高级接口" />
                </el-select>
              </div>
              <div class="docs-limit-chunk">
                <span>频次限制：</span>
                <el-select
                  size="small"
                  v-model={this.getSecondDocData.visite_frequency}
                >
                  <el-option value="10" label="10次/分" />
                  <el-option value="20" label="20次/分" />
                  <el-option value="30" label="30次/分" />
                  <el-option value="40" label="40次/分" />
                  <el-option value="50" label="50次/分" />
                  <el-option value="60" label="60次/分" />
                  <el-option value="100" label="100次/分" />
                  <el-option value="200" label="200次/分" />
                  <el-option value="300" label="300次/分" />
                  <el-option value="400" label="400次/分" />
                  <el-option value="500" label="500次/分" />
                  <el-option value="600" label="600次/分" />
                </el-select>
              </div>
            </div>
          ) : (
            <div class="docs-text">
              <p class="docs-interface-text">
                访问级别：
                <span class="docs-strong">
                  {this.getSecondDocData.visite_level === "1"
                    ? "普通接口"
                    : "高级接口"}
                </span>
              </p>
              <p class="docs-interface-text">
                频次限制：
                <span class="docs-strong">
                  {this.getSecondDocData.visite_frequency}
                </span>
                次/分
              </p>
            </div>
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">URL</p>
          {this.isEdit ? (
            <div class="docs-item-content">
              <el-input
                class="docs-url-input"
                v-model={this.getSecondDocData.url}
                placeholder="请输入url"
              />
            </div>
          ) : (
            <p class="docs-text">{this.getSecondDocData.url}</p>
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">HTTP Method</p>
          {this.isEdit ? (
            <div class="docs-item-content">
              <el-select size="small" v-model={this.getSecondDocData.method}>
                <el-option value="POST" label="POST" />
                <el-option value="GET" label="GET" />
              </el-select>
            </div>
          ) : (
            <p class="docs-text">{this.getSecondDocData.method}</p>
          )}
        </div>
        <div class="docs-header docs-item">
          <p class="docs-title">HTTP Header</p>
          {this.isEdit ? (
            <div class="docs-header-desc">
              <div class="docs-header-desc-title">
                <p v-show={this.getSecondDocData.method === "POST"}>
                  Content-Type
                </p>
                <p v-show={this.getSecondDocData.method === "POST"}>Accept</p>
                <p>Key</p>
              </div>
              <div class="docs-header-desc-content">
                <p v-show={this.getSecondDocData.method === "POST"}>
                  <el-select
                    size="mini"
                    v-model={this.getSecondDocData.content_type}
                    placeholder="请选择"
                  >
                    {this.contentType.map(item => {
                      return <el-option key={item} label={item} value={item} />;
                    })}
                  </el-select>
                </p>
                <p v-show={this.getSecondDocData.method === "POST"}>
                  <el-select
                    size="mini"
                    v-model={this.getSecondDocData.accept}
                    placeholder="请选择"
                  >
                    {this.accept.map(item => {
                      return <el-option key={item} label={item} value={item} />;
                    })}
                  </el-select>
                </p>
                <p>你在控制台获取的Key</p>
              </div>
            </div>
          ) : (
            <div class="docs-header-desc">
              <div class="docs-header-desc-title">
                <p v-show={this.getSecondDocData.method === "POST"}>
                  Content-Type
                </p>
                <p v-show={this.getSecondDocData.method === "POST"}>Accept</p>
                <p>Key</p>
              </div>
              <div class="docs-header-desc-content">
                <p v-show={this.getSecondDocData.method === "POST"}>
                  {this.getSecondDocData.content_type}
                </p>
                <p v-show={this.getSecondDocData.method === "POST"}>
                  {this.getSecondDocData.accept}
                </p>
                <p>你在控制台获取的Key</p>
              </div>
            </div>
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">
            HTTP 请求参数
            <span class="docs-title-small">（x-www-form-urlencoded格式）</span>
          </p>
          <div class="docs-body-analysis">
            <table
              class={{
                "docs-body-table": true,
                "docs-body-table-padding": this.isEdit
              }}
            >
              <tbody>
                <tr>
                  <th width="100px">参数名</th>
                  <th width="122px">必选</th>
                  <th width="120px">默认值</th>
                  <th width="140px">类型及范围</th>
                  <th>说明</th>
                  <th>示例值</th>
                </tr>
                {this.request_body.map(item => {
                  return (
                    <tr ref="reqList" refInFor>
                      <td data-key={item.parameter}>{item.parameter}</td>
                      <td>
                        {this.isEdit ? (
                          <el-input size="small" v-model={item.isNeed} />
                        ) : (
                          item.isNeed
                        )}
                      </td>
                      <td data-value={item.value}>
                        {this.isEdit ? (
                          <el-input size="small" v-model={item.value} />
                        ) : (
                          item.value
                        )}
                      </td>
                      <td data-type={item.type}>{item.type}</td>
                      <td>
                        {this.isEdit ? (
                          <el-input
                            type="textarea"
                            resize="none"
                            autosize
                            v-model={item.desc}
                          />
                        ) : (
                          <div
                            class="docs-body-table-line"
                            domPropsInnerHTML={item.desc}
                          />
                        )}
                      </td>
                      <td>
                        {this.isEdit ? (
                          <el-input size="small" v-model={item.exampleVlaue} />
                        ) : (
                          item.exampleVlaue
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {this.isEdit ? (
              <el-input
                class="docs-body-table-comment-input"
                type="textarea"
                autosize
                resize="none"
                placeholder="请输入注释"
                v-model={this.getSecondDocData.req_comment}
              />
            ) : (
              this.getSecondDocData.req_comment && (
                <div class="docs-body-table-comment">
                  注：
                  <span domPropsInnerHTML={this.getSecondDocData.req_comment} />
                </div>
              )
            )}
          </div>
          <p class="docs-title">请求参数实例</p>
          <div class="docs-item-content" v-show={this.isEdit}>
            <el-input
              class="docs-textarea"
              type="textarea"
              resize="none"
              autosize={{ minRows: 3 }}
              placeholder="请输入请求Json实例"
              v-model={this.getSecondDocData.request_json}
              onBlur={this.reqTextAreaBlur}
            />
          </div>
          <div class="docs-code" ref="requestJson" v-show={!this.isEdit} />
          <p class="docs-title" style="margin-top: 50px;">
            HTTP请求示例
          </p>
          <div class="docs-item-content" v-show={this.isEdit}>
            <el-input
              class="docs-textarea"
              type="textarea"
              resize="none"
              autosize={{ minRows: 2 }}
              placeholder="请输入请求示例"
              v-model={this.getSecondDocData.req_example}
            />
          </div>
          <div class="docs-code" ref="reqExample" v-show={!this.isEdit} />
        </div>
        <div class="docs-item">
          <p class="docs-title">
            HTTP 返回 Body<span class="docs-title-small">&nbsp;(Json格式)</span>
          </p>
          <div class="docs-body-analysis">
            <table
              class={{
                "docs-body-table": true,
                "docs-body-table-padding": this.isEdit
              }}
            >
              <tbody>
                <tr>
                  <th width="200px">参数名</th>
                  <th width="140px">类型及范围</th>
                  <th>说明</th>
                </tr>
                {this.reponse_body.map(item => {
                  return (
                    <tr>
                      <td data-key={item.parameter}>{item.parameter}</td>
                      <td data-value={item.type}>{item.type}</td>
                      <td>
                        {this.isEdit ? (
                          <el-input
                            type="textarea"
                            resize="none"
                            autosize
                            v-model={item.desc}
                          />
                        ) : (
                          <div
                            class="docs-body-table-line"
                            domPropsInnerHTML={item.desc}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {this.isEdit ? (
              <el-input
                class="docs-body-table-comment-input"
                type="textarea"
                autosize
                resize="none"
                placeholder="请输入注释"
                v-model={this.getSecondDocData.res_comment}
              />
            ) : (
              this.getSecondDocData.res_comment && (
                <div class="docs-body-table-comment">
                  注：
                  <span domPropsInnerHTML={this.getSecondDocData.res_comment} />
                </div>
              )
            )}
          </div>
          <p class="docs-title">返回Json实例</p>
          <div class="docs-item-content" v-show={this.isEdit}>
            <el-input
              class="docs-textarea"
              type="textarea"
              resize="none"
              autosize={{ minRows: 3 }}
              placeholder="请输入返回Json实例"
              v-model={this.getSecondDocData.reponse_json}
              onBlur={this.resTextAreaBlur}
            />
          </div>
          <div class="docs-code" ref="responseJson" v-show={!this.isEdit} />
        </div>
        {this.getSecondDocData.async_state === "2" && (
          <div>
            <div class="docs-item">
              <p class="docs-title">异步任务相关接口</p>
              <div class="docs-item-content docs-item-content-async">
                <span class="docs-item-content-async-title">
                  数据获取接口：
                </span>
                {this.isEdit ? (
                  <el-input
                    size="small"
                    v-model={this.asyncData.getUrl}
                    placeholder="请输入接口url"
                  />
                ) : (
                  <p class="docs-item-content-async-url">
                    {this.asyncData.getUrl}
                  </p>
                )}
              </div>
              <div
                class="docs-item-content docs-item-content-async"
                style="display: none;"
              >
                <span class="docs-item-content-async-title">
                  任务查询接口：
                </span>
                {this.isEdit ? (
                  <el-input
                    size="small"
                    v-model={this.asyncData.searchUrl}
                    placeholder="请输入接口url"
                  />
                ) : (
                  <p class="docs-item-content-async-url">
                    {this.asyncData.searchUrl}
                  </p>
                )}
              </div>
            </div>
            <div class="docs-item docs-body">
              <p class="docs-title">
                异步任务（数据获取）HTTP 返回 Body
                <span class="docs-title-small">&nbsp;(Json格式)</span>
              </p>
              <div class="docs-body-analysis">
                <table class="docs-body-table docs-body-table-padding">
                  <thead>
                    <tr>
                      <th width="180px">参数名</th>
                      <th width="140px">类型及范围</th>
                      <th>说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.asyncData.resBody &&
                      this.asyncData.resBody.map(item => {
                        return (
                          <tr>
                            <td data-key={item.parameter}>{item.parameter}</td>
                            <td data-type={item.type}>{item.type}</td>
                            <td>
                              {this.isEdit ? (
                                <el-input
                                  type="textarea"
                                  resize="none"
                                  autosize
                                  v-model={item.desc}
                                />
                              ) : (
                                <div
                                  class="docs-body-table-line"
                                  domPropsInnerHTML={item.desc}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {this.isEdit ? (
                  <el-input
                    class="docs-body-table-comment-input"
                    type="textarea"
                    autosize
                    resize="none"
                    placeholder="请输入注释"
                    v-model={this.asyncData.res_comment}
                  />
                ) : (
                  this.asyncData.res_comment && (
                    <div class="docs-body-table-comment">
                      注：
                      <span domPropsInnerHTML={this.asyncData.res_comment} />
                    </div>
                  )
                )}
              </div>
              <p class="docs-title">异步任务（数据获取）返回Json实例</p>
              <div class="docs-item-content" v-show={this.isEdit}>
                <el-input
                  class="docs-textarea"
                  type="textarea"
                  resize="none"
                  autosize={{ minRows: 3 }}
                  placeholder="请输入返回Json实例"
                  v-model={this.asyncData.resJsonData}
                  onBlur={this.asyncJsonBlur}
                />
                <el-input
                  class="docs-body-table-comment-input"
                  type="textarea"
                  autosize
                  resize="none"
                  placeholder="请输入注释"
                  v-model={this.asyncData.res_Json_comment}
                />
              </div>
              <div
                class="docs-code"
                ref="asyncResponseJson"
                v-show={!this.isEdit}
              />
              {this.asyncData.res_Json_comment && (
                <div
                  v-show={!this.isEdit}
                  class="docs-body-table-comment"
                  style="margin-left:12px;"
                >
                  注：
                  <span domPropsInnerHTML={this.asyncData.res_Json_comment} />
                </div>
              )}
            </div>
          </div>
        )}
        <div class="docs-item">
          <p class="docs-title">状态码说明</p>
          <div class="docs-body-analysis">
            <table class="docs-body-table docs-body-table-padding">
              <thead>
                <tr>
                  <th width="120px">状态码</th>
                  <th>说明</th>
                  {this.isEdit ? (
                    <th width="200px">
                      <el-button
                        type="primary"
                        size="mini"
                        onClick={this.addStatusTr}
                      >
                        添加一行
                      </el-button>
                    </th>
                  ) : (
                    ""
                  )}
                </tr>
              </thead>
              <tbody>
                {this.status_collection.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {this.isEdit ? (
                          <el-input
                            type="textarea"
                            resize="none"
                            autosize
                            v-model={item.status}
                          />
                        ) : (
                          item.status
                        )}
                      </td>
                      <td>
                        {this.isEdit ? (
                          <el-input
                            type="textarea"
                            resize="none"
                            autosize
                            v-model={item.desc}
                          />
                        ) : (
                          item.desc
                        )}
                      </td>
                      {this.isEdit ? (
                        <td>
                          <el-button
                            type="danger"
                            size="mini"
                            onClick={this.deleteStatusTr.bind(this, index)}
                          >
                            删除
                          </el-button>
                        </td>
                      ) : (
                        ""
                      )}
                    </tr>
                  );
                })}
              </tbody>
              <tbody />
            </table>
            {this.isEdit ? (
              <el-input
                class="docs-body-table-comment-input"
                type="textarea"
                autosize
                resize="none"
                placeholder="请输入注释"
                v-model={this.getSecondDocData.status_comment}
              />
            ) : (
              this.getSecondDocData.status_comment && (
                <div class="docs-body-table-comment">
                  注：
                  <span
                    domPropsInnerHTML={this.getSecondDocData.status_comment}
                  />
                </div>
              )
            )}
          </div>
        </div>
        <div class="docs-item">
          <p class="docs-title">计费</p>
          {this.isEdit ? (
            <div class="docs-item-content">
              <el-input
                placeholder="请输入内容"
                v-model={this.getSecondDocData.price}
                class="docs-input-with-select"
              >
                <el-select
                  v-model={this.getSecondDocData.price_model}
                  slot="append"
                  placeholder="请选择"
                  class="docs-input-with-select-in"
                >
                  <el-option label="unit/次" value={"1"} />
                  <el-option label="unit/条" value={"2"} />
                </el-select>
              </el-input>
            </div>
          ) : (
            <p class="docs-text">
              {this.getSecondDocData.price}
              {this.getSecondDocData.price_model === "1"
                ? "unit/次"
                : "unit/条"}
            </p>
          )}
        </div>
        <div class="docs-item">
          <p class="docs-title">其它</p>
          <div class="docs-item-content">
            <el-checkbox-group
              v-model={this.checkList}
              onChange={this.checkHander}
            >
              <el-checkbox disabled={!this.isEdit} label="新" />
              <el-checkbox disabled={!this.isEdit} label="高" />
              <el-checkbox disabled={!this.isEdit} label="定" />
            </el-checkbox-group>
          </div>
          {this.isEdit ? (
            <div class="docs-item-content">
              <el-input
                type="textarea"
                resize="none"
                autosize={{ minRows: 2 }}
                placeholder="若无任何填写内容，默认为“无”"
                v-model={this.getSecondDocData.comments}
              />
            </div>
          ) : (
            <p
              class="docs-text"
              domPropsInnerHTML={
                this.getSecondDocData.comments
                  ? this.getSecondDocData.comments
                  : "无"
              }
            />
          )}
        </div>
        <div class="second-foot">
          {this.getSecondDocData.status !== "-1" ? (
            <div class="second-foot-btn">
              {!this.isEdit && (
                <el-button
                  plain
                  class="second-foot-clone"
                  onClick={this.cloneDoc}
                >
                  克隆
                </el-button>
              )}
              <el-button
                plain
                class="second-foot-delete"
                onClick={this.confirmDelete}
              >
                删除
              </el-button>
              {this.isEdit ? (
                <el-button
                  type="primary"
                  plain
                  class="second-foot-save"
                  loading={!this.isClick}
                  onClick={this.saveSecond}
                >
                  {this.isClick ? "保存" : "保存中"}
                </el-button>
              ) : (
                <el-button
                  class="second-foot-edit"
                  type="primary"
                  plain
                  onClick={() => (this.isEdit = true)}
                >
                  编辑
                </el-button>
              )}
            </div>
          ) : (
            ""
          )}
          <p class="second-foot-time">
            文档更新时间：
            {stringDateFormat(
              "yyyy-MM-dd",
              this.getSecondDocData.update_time
                ? this.getSecondDocData.update_time
                : ""
            )}
          </p>
        </div>
      </div>
    );
  }
  /* eslint-disable */
  reponse_body = [];
  request_body = [];
  status_collection = [];
  asyncData = {};
  /* eslint-disable */
  isEdit = false;
  isClick = true;
  contentType = [
    "application/x-www-form-urlencoded;charset=utf-8",
    "application/json;charset=utf-8"
  ];
  accept = ["application/json", "text/plain", "application/xml", "*/*"];
  cascader = {};
  checkList = [];
  @Getter getTitleCascader;
  @Getter getSecondDocData;
  created() {
    this.getData();
  }
  beforeRouteUpdate(to, from, next) {
    next();
    this.getData();
  }
  updated() {
    if (!this.isEdit) {
      this.$refs.responseJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${this.getSecondDocData.reponse_json}</code></pre>`;
      this.$refs.requestJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${this.getSecondDocData.request_json}</code></pre>`;
      if (this.getSecondDocData.req_example) {
        this.$refs.reqExample.innerHTML = `<pre class="language-bash line-numbers" data-start="1"><code>${this.getSecondDocData.req_example}</code></pre>`;
      }
      if (this.asyncData.resJsonData) {
        this.$refs.asyncResponseJson.innerHTML = `<pre class="language-json line-numbers" data-start="1"><code>${this.asyncData.resJsonData}</code></pre>`;
      }
      this.$nextTick(() => {
        Prism.highlightAll();
      });
    }
  }
  @Action getDocumentDetail;
  @Action updateSecondDoc;
  @Action deleteScondDoc;
  @Action cloneDocument;
  @Action setIsGetCloneStatus;
  getData() {
    this.getDocumentDetail({
      level: "3",
      id: this.$route.params.id
    }).then(res => {
      if (this.getSecondDocData.reponse_body) {
        this.reponse_body = JSON.parse(this.getSecondDocData.reponse_body);
      }
      if (this.getSecondDocData.request_body) {
        this.request_body = JSON.parse(this.getSecondDocData.request_body);
      }
      if (this.getSecondDocData.status_collection) {
        this.status_collection = JSON.parse(
          this.getSecondDocData.status_collection
        );
      }
      if (this.getSecondDocData.async_data) {
        this.asyncData = JSON.parse(this.getSecondDocData.async_data);
      }
      if (this.getSecondDocData.cascader) {
        this.cascader = JSON.parse(this.getSecondDocData.cascader);
      }
      this.checkList =
        this.getSecondDocData.check_list &&
        JSON.parse(this.getSecondDocData.check_list);
      if (!res.data.value) {
        return this.$router.push({ path: "/admin" });
      }
    });
  }
  saveSecond() {
    if (!this.isClick) return;
    this.isClick = false;
    const params = Object.assign({}, this.getSecondDocData);
    params.reponse_body = JSON.stringify(this.reponse_body);
    params.request_body = JSON.stringify(this.request_body);
    params.status_collection = JSON.stringify(this.status_collection);
    params.level = "3";
    params.async_data = JSON.stringify(this.asyncData);
    params.cascader = JSON.stringify(this.cascader);
    params.check_list = JSON.stringify(this.checkList);
    delete params.status;
    this.updateSecondDoc(params).then(res => {
      this.isClick = true;
      if (res.data.value > 0) {
        this.$message({
          showClose: true,
          message: "保存成功",
          type: "success"
        });
        this.isEdit = false;
      } else {
        this.$message({
          showClose: true,
          message: "保存失败",
          type: "error"
        });
      }
    });
  }
  reqTextAreaBlur() {
    if (!this.getSecondDocData.request_json) return;
    const json = strToJson(this.getSecondDocData.request_json);
    if (!json) {
      this.$notify.error({
        title: "错误",
        message: "请输入标准的JSON格式",
        duration: 6000
      });
    }
    if (judgmentType(json) === "[object Object]") {
      this.request_body = diffReqData(this.request_body, json);
    }
  }
  resTextAreaBlur() {
    if (!this.getSecondDocData.reponse_json) return;
    this.reponse_body = diffResData(
      this.reponse_body,
      this.generateData(this.getSecondDocData.reponse_json)
    );
  }
  asyncJsonBlur() {
    if (!this.asyncData.resJsonData) return;
    this.asyncData.resBody = diffResData(
      this.asyncData.resBody,
      this.generateData(this.asyncData.resJsonData)
    );
  }
  generateData(param) {
    const data = strToJson(param);
    if (!data) {
      this.$notify.error({
        title: "错误",
        message: "请输入标准的JSON格式",
        duration: 6000
      });
    }
    const json = data.data || data.aggs;
    let cacheJson = {};
    if (judgmentType(json) === "[object Object]") {
      cacheJson = json;
    }
    if (judgmentType(json) === "[object Array]") {
      if (json.length && judgmentType(json[0]) === "[object Object]") {
        cacheJson = json[0];
      }
    }
    let obj = {};
    Object.entries(cacheJson).forEach(([key, value]) => {
      let data = null;
      if (judgmentType(value) === "[object Object]") {
        data = value;
      }
      if (judgmentType(value) === "[object Array]") {
        if (value.length && judgmentType(value[0]) === "[object Object]") {
          data = value[0];
        }
      }
      if (data) {
        obj[key] = value;
        Object.entries(data).forEach(([linKey, lineValue]) => {
          obj[`${key}.${linKey}`] = lineValue;
        });
      } else {
        obj[key] = value;
      }
    });
    return obj;
  }
  confirmDelete() {
    this.$msgbox
      .confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(msg => {
        this.deleteScondDoc({ id: this.$route.params.id })
          .then(res => {
            if (res.data.value > 0) {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                showClose: true,
                message: "删除失败",
                type: "warning"
              });
            }
          })
          // eslint-disable-next-line
          .catch(err => {
            this.$message({
              showClose: true,
              message: "删除失败",
              type: "warning"
            });
          });
      })
      .catch(() => {});
  }
  addStatusTr() {
    this.status_collection.push({
      status: "",
      desc: ""
    });
  }
  deleteStatusTr(index) {
    this.status_collection.splice(index, 1);
  }
  cloneDoc() {
    this.setIsGetCloneStatus(true);
    this.cloneDocument(this.getSecondDocData);
    this.$router.push({ path: "/admin/create" });
  }
  handleChange(val) {
    this.cascader.text = "";
    this.getTitleCascader.forEach(item => {
      if (item.value === val[0]) {
        this.cascader.text += item.label + "/";
        item.children.forEach(oneItem => {
          if (oneItem.value === val[1]) {
            this.cascader.text += oneItem.label;
          }
        });
      }
    });
    this.getSecondDocData.parent_id = val[1];
  }
  checkHander(val) {
    const len = val.length;
    if (val[len - 1] === "高") {
      const index = val.findIndex(value => {
        return value === "定";
      });
      if (index > -1) {
        val.splice(index, 1);
      }
    }
    if (val[len - 1] === "定") {
      const index = val.findIndex(value => {
        return value === "高";
      });
      if (index > -1) {
        val.splice(index, 1);
      }
    }
    this.getSecondDocData.xin = "0";
    this.getSecondDocData.high = "0";
    this.getSecondDocData.custom = "0";
    val.forEach(item => {
      if (item === "新") {
        this.getSecondDocData.xin = "1";
      }
      if (item === "高") {
        this.getSecondDocData.high = "1";
      }
      if (item === "定") {
        this.getSecondDocData.custom = "1";
      }
    });
    this.checkList = val;
  }
}
</script>

<style lang="postcss">
@import "../../assets/css/_pub.css";
.second {
  &-delete {
    background-image: url(~@/assets/img/already-delete.png);
    background-position: 695px 56px;
    background-repeat: no-repeat;
  }
  &-foot {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    padding-right: 65px;
    &-time {
      font-size: var(--font-size);
      color: #999;
      margin-top: 15px;
    }
    &-btn {
      display: flex;
    }
    &-delete,
    &-edit,
    &-save,
    &-clone {
      @mixin size 90px, 30px;
      @extend flex-midden;
      padding: 0;
      &:focus {
        outline: none;
      }
    }
    &-clone {
      margin-right: 35px;
    }
    &-delete {
      // border: 1px solid var(--border-gray);
      margin-right: 35px;
    }
    &-edit,
    &-save {
      border: 0;
      background-color: var(--newrank-color) !important;
      color: var(--white) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/SecondLevel.vue